import React from 'react';
import { Filter, Clock, TrendingDown, AlertCircle, CheckCircle } from 'lucide-react';

const SectionTitle = ({ subtitle, title, align = 'left' }) => (
  <div className={`mb-12 ${align === 'center' ? 'text-center' : ''}`}>
    <div className={`flex items-center gap-2 mb-3 ${align === 'center' ? 'justify-center' : ''}`}>
      <div className="w-12 h-0.5 bg-[#F49611]"></div>
      <span className="text-[#F49611] font-medium uppercase tracking-wider text-sm">{subtitle}</span>
    </div>
    <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">{title}</h2>
  </div>
);

const LSGPractice = () => {
  const filters = [
    {
      icon: Filter,
      title: "Age and risk profile",
      description: "",
      index: 1
    },
    {
      icon: Clock,
      title: "Cash flow requirements",
      description: "",
      index: 2
    },
    {
      icon: TrendingDown,
      title: "Financial goals",
      description: "",
      index: 3
    },
    {
      icon: AlertCircle,
      title: "Existing asset base",
      description: "",
      index: 4
    }
  ];

  return (
    <div className="bg-white pt-12">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Why This Matters Section - Left Side */}
          <div>
            <SectionTitle 
              subtitle="Investment Approach"
              title="Why LSG Works"
            />
            
            <p className="text-lg text-gray-600 mb-8">
              Markets are unpredictable. Your asset allocation shouldn’t be.
              <br />
              With LSG, you always know which part of your portfolio is meant to handle which purpose—so you don’t overreact to headlines or short-term movements.
            </p>
            
            <div className="bg-white p-6 rounded-lg border-l-4 border-[#F49611] italic text-gray-700 font-medium mb-8">
              "The best investment strategy is the one you can stick with." – Morgan Housel
            </div>
            
          </div>
          
          {/* Other Filters Section - Right Side */}
          <div className="bg-[#E8EEF6] rounded-2xl p-8 md:p-12">
            <div className="space-y-6">
              <h3 className="text-2xl font-bold text-[#113262] mb-6">LSG in Practice: Tailored for You</h3>
              <p className="text-gray-700 mb-6">
              We personalise the LSG framework for every client based on:
              </p>
              
              {filters.map((filter, index) => (
                <div key={index} className="flex items-start gap-4 mb-5">
                  <div className="w-6 h-6 rounded-full bg-[#F49611] flex items-center justify-center flex-shrink-0">
                    <CheckCircle className="w-4 h-4 text-white" />
                  </div>
                  <div>
                    <span className="font-medium text-[#113262]">{filter.title}</span>
                    <span className="text-gray-700 ml-1">{filter.description}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LSGPractice;